webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.6d6410d.png";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eaf97ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ZidX");
function injectStyle (ssrContext) {
  __webpack_require__("SCjb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eaf97ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__("M93x");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_2__App_vue__["a" /* default */]);
	}
});

/***/ }),

/***/ "SCjb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZidX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__("7Otq")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    attrs: {
      "id": "newPassword",
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "newPassword"
    }
  }, [_vm._v("New Password")])]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    attrs: {
      "id": "confirmPassword",
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirmPassword"
    }
  }, [_vm._v("Confirm Password")])])]), _vm._v(" "), _c('div', {
    staticClass: "reset-button"
  }, [(_vm.validToken && !_vm.resetSuccessful) ? _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.resetPassword()
      }
    }
  }, [_vm._v("Reset Password")]) : _vm._e(), _vm._v(" "), (!_vm.validToken || _vm.resetSuccessful) ? _c('button', [_vm._v("Reset Password")]) : _vm._e()]), _vm._v(" "), (!_vm.validToken && !_vm.resetSuccessful) ? _c('div', {
    staticClass: "invalid-token-overlay"
  }, [_c('div', {
    staticClass: "invalid-token"
  }, [_c('h1', [_vm._v("Error")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "invalid-token-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.closeWindow()
      }
    }
  }, [_vm._v("Exit")])])]) : _vm._e(), _vm._v(" "), (_vm.resetSuccessful) ? _c('div', {
    staticClass: "reset-success-overlay"
  }, [_c('div', {
    staticClass: "reset-success"
  }, [_c('h1', [_vm._v("Password Reset!")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "reset-success-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.closeWindow()
      }
    }
  }, [_vm._v("Exit")])])]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-text"
  }, [_vm._v("\n\t\t\t\t\tReset password token is invalid or has expired."), _c('br'), _vm._v("\n\t\t\t\t\tPlease try requesting a password reset from the app again.\n\t\t\t\t")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-text"
  }, [_vm._v("\n\t\t\t\t\tYou can now log in with your new password on the"), _c('br'), _vm._v("\n\t\t\t\t\tPerfect Portions App.\n\t\t\t\t")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	data: function data() {
		return {
			newPassword: '',
			confirmPassword: '',
			api: 'https://api.perfectportions.greatergoods.com/v1/account/reset-password',
			token: window.location.pathname.split('/').slice(-1)[0],
			validToken: true,
			resetSuccessful: false
		};
	},

	created: function created() {
		var _this = this;

		this.$http.post(this.api + '/check', { token: this.token }).then(function (res) {
			_this.validToken = res.body.isValid;
		}, function (err) {
			_this.validToken = false;
		});
	},
	methods: {
		closeWindow: function closeWindow() {
			window.close();
		},
		resetPassword: function resetPassword() {
			var _this2 = this;

			var data = {
				token: this.token,
				password: this.newPassword
			};
			this.$http.post(this.api + '/submit', data).then(function (res) {
				if (res.status === 204) {
					_this2.resetSuccessful = true;
				}
			}, function (err) {
				_this2.validToken = false;
			});
		}
	}
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.2de2edddb461245faf4b.js